import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Fetch all published blog posts with event dates
 * @returns {Promise<Array>} Array of blog posts with event dates
 */
export const fetchEventBlogs = async () => {
  try {
    // Query for published blogs with event dates
    const blogsQuery = query(
      collection(db, 'blogs'),
      where('isPublished', '==', true),
      where('eventDate', '!=', null)
    );
    
    const querySnapshot = await getDocs(blogsQuery);
    
    const eventBlogs = [];
    querySnapshot.forEach((doc) => {
      eventBlogs.push({
        ...doc.data(),
        id: doc.id,
      });
    });
    
    return eventBlogs;
  } catch (error) {
    console.error('Error fetching event blogs:', error);
    throw error;
  }
};